import Ledger from "@/components/Ledger";

const CATS = [
  { value: "TRAFFIC", label: "Traffic Fine" },
  { value: "CUSTOMER_COMPLAINT", label: "Customer Complaint" },
  { value: "VEHICLE_DAMAGE", label: "Vehicle Damage Recovery" },
  { value: "OFFICE", label: "Office Fine" },
  { value: "ASSET_DAMAGE", label: "Asset Damage Recovery" },
  { value: "UNIFORM", label: "Uniform Fine" },
  { value: "SAFETY", label: "Safety Violation" },
  { value: "LATE", label: "Late Reporting" },
  { value: "CUSTOM", label: "Custom Fine" },
];
export default function Fines() {
  return <Ledger title="Fines & Penalties" endpoint="fines" categories={CATS} />;
}
